import {observer} from "mobx-react";
import {Area, AreaChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {ChartDataItemType, kpiWeighingDashboardStore} from "../../../store";
import {useEffect, useState} from "react";
import {TooltipContent} from "./TooltipContent";

const backlogColor = '#7E57C2'  // Mittleres Violett
const incomeColor = '#1E88E5'   // Klares Azurblau

const WeighingChart = observer(function WeighingChart() {
    const chartData = kpiWeighingDashboardStore.chartData
    const [data, setData] = useState<ChartDataItemType[]>([])

    useEffect(() => {
        setData(JSON.parse(JSON.stringify(chartData)) as ChartDataItemType[])
    }, [chartData])

    return <>
        <div style={{
            flex: '1',
            height: '20em'
        }}>
            <ResponsiveContainer>
                <AreaChart data={data}>
                    <Area type="linear" dataKey="incoming" name={"Eingänge"} stroke={incomeColor} fill={incomeColor} fillOpacity={0.6} />
                    <Area type="linear" dataKey="backlog" name={"Rückstände"} stroke={backlogColor} fill={backlogColor} fillOpacity={0.6} />

                    <XAxis type={'category'} dataKey="date"/>
                    <YAxis type={'number'}/>
                    <Tooltip content={TooltipContent}/>
                    <Legend/>
                </AreaChart>
            </ResponsiveContainer>
        </div>
    </>
})

export {
    WeighingChart
}
